import * as React from "react";
import { singleton } from "logic/singleton";
const WidgetResultContext = React.createContext(void 0);
export default singleton("contexts.TestContext", () => WidgetResultContext);
